import { render, staticRenderFns } from "./MyMessageComponent.vue?vue&type=template&id=677fcbae&"
import script from "./MyMessageComponent.vue?vue&type=script&lang=js&"
export * from "./MyMessageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports